module.exports = __webpack_public_path__ + "static/logo_blue-4962efd1c55a95b743c21c8b5e933d97.svg";